import styled from 'styled-components'
import { Title, Text, Button } from 'components/common'

export const Container = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  text-align: center;
`

export const ScreenTitle = styled(Title)`
  margin-bottom: 10px;
  font-weight: 500;
  font-size: 20px;
`

export const ScreenSubtitle = styled(Text)`
  margin: 0;
  text-align: center;
  color: ${props => props.theme.additionalTextColor};
`

export const ButtonComponent = styled(Button)`
  width: 100%;
  justify-content: center;
  margin-bottom: 16px;
`
